// import React, { useEffect, useRef, useState } from 'react'
// import './MessageScreenBody.css'
// import { connect } from 'react-redux'
// import MessageScreenBodyItem from '../MessageScreenBodyItem/MessageScreenBodyItem'
// import { chatSelector } from '../../../../../store/selector'
// import LoadingScreen from '../LoadingScreen/LoadingScreen'
// import { chatAction, messageAction } from '../../../../../store/action'

// function MessageScreenBody({ messageList, selectedAssignedList, messages, loading, paginationInfo, dynamicUpdate, configProcessor, ...props }) {
//   const chatContainerRef = useRef(null);
//   const [heightFromBottom, setHeightFromBottom] = useState(0)
//   const [lastMessage, setLastMessage] = useState(null)

//   const isScrollbarAtBottom = () => {
//     if (!chatContainerRef.current) return true;
//     const container = chatContainerRef.current;
//     // const lastElementHeight = container.lastElementChild && container.lastElementChild.getBoundingClientRect().height || 79;
//     const lastElementHeight = container.lastElementChild ? container.lastElementChild.offsetHeight + parseInt(window.getComputedStyle(container.lastElementChild).marginTop) + parseInt(window.getComputedStyle(container.lastElementChild).marginBottom) : 0;
//     return container.scrollHeight - container.scrollTop - lastElementHeight === container.clientHeight;
//   };
//   const scroll = (pixelsFromBottom) => {
//     chatContainerRef.current.scrollTop =
//       chatContainerRef.current.scrollHeight -
//       chatContainerRef.current.clientHeight -
//       pixelsFromBottom;
//   };

//   useEffect(() => {
//     // If new message comes & user is at bottom of the page, then scroll to bottom
//     const container = chatContainerRef.current;
//     if (isScrollbarAtBottom() && container) {
//       scroll(0)
//       return;
//     }
//     // If previous messages are fetched then prevent scroll bar to go at top
//     // if(heightFromBottom !== 0){
//       const currMsgList = messageList[selectedAssignedList['identifier']];
//       const currLastMsg = currMsgList && currMsgList[currMsgList.length - 1]
//       if(lastMessage && currLastMsg && (lastMessage.timeStamp === currLastMsg.timeStamp)){
//         scroll(heightFromBottom)
//       }
//       // when new message comes & user is not at bottom
//       setHeightFromBottom(heightFromBottom)
//       setLastMessage(currLastMsg)
//     // }
//   }, [messageList[selectedAssignedList['identifier']]]);

//   useEffect(() => {
//     scroll(0)
//   }, [loading])

//   const handleScroll = (e) => {
//     const container = chatContainerRef.current;
//     if (e.currentTarget.scrollTop === 0) {
//       container.addEventListener('scroll',()=>{
//         const { scrollTop, scrollHeight, clientHeight } = container;
//         const heightFromBottom = scrollHeight - scrollTop - clientHeight;
//         setHeightFromBottom(heightFromBottom)
//       })
//       dynamicUpdate({data: { key: `mainScreenLoading`, value: true }})
//       const currentPaginationInfo = paginationInfo[selectedAssignedList.identifier]
//       const { page_no, count } = currentPaginationInfo;
//       if(count - (20 * page_no) > 0){
//         dynamicUpdate({data: { key: `paginationInfo.${selectedAssignedList.identifier}`, value: {...paginationInfo[selectedAssignedList.identifier] || {}, page_no: page_no + 1} }})
//         // fetch more messages
//         configProcessor('getHistory', {
//           identifier: selectedAssignedList.identifier,
//           page_no: page_no + 1
//         })
//       }
//       container.removeEventListener('scroll',()=>{})
//     }
//   }

//   return (
//     <div {...props} onScroll={handleScroll} ref={chatContainerRef}>
//       {loading && (
//         <LoadingScreen />
//       )}
//       {messages.map(message => {
//         return <MessageScreenBodyItem message={message} />
//       })}
//     </div>
//   )
// }

// const stateToProps = state => ({
//   messageList: chatSelector.getChatDynamic(state, 'messageList'),
//   paginationInfo: chatSelector.getChatDynamic(state, 'paginationInfo'),
//   selectedAssignedList: chatSelector.getChatDynamic(state, 'selectedAssignedList'),
//   messages: chatSelector.getCurrentChats(state),
//   loading: chatSelector.getLoadingStatus(state),
// });

// const dispatchToProps = dispatch => ({
//   configProcessor: (type, messageData) => {
//     dispatch(messageAction.configProcessor(type, messageData));
//   },
//   dynamicUpdate: (type, messageData) => {
//     dispatch(chatAction.dynamicUpdate(type, messageData));
//   }
// });

// export default connect(stateToProps, dispatchToProps)(MessageScreenBody);
import React, { useEffect, useRef, useState } from "react";
import "./MessageScreenBody.css";
import { connect } from "react-redux";
import MessageScreenBodyItem from "../MessageScreenBodyItem/MessageScreenBodyItem";
import { chatSelector } from "../../../../../store/selector";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { chatAction, messageAction } from "../../../../../store/action";
import { useChatScrollHandler } from "./useChatScrollHandler"; // Import the custom hook
import { getUUID } from "../../utils";

function MessageScreenBody({
  messageList,
  selectedAssignedList,
  messages,
  loading,
  paginationInfo,
  dynamicUpdate,
  configProcessor,
  ...props
}) {
  const chatContainerRef = useRef(null);
  const scrollPositions = useRef({});

  useEffect(() => {
    return () => {
      if (chatContainerRef.current && selectedAssignedList && selectedAssignedList.sessionId) {
        scrollPositions.current[selectedAssignedList.sessionId] = chatContainerRef.current.scrollTop;
      }
    };
  }, [selectedAssignedList]);

  useEffect(() => {
    if (chatContainerRef.current && selectedAssignedList && selectedAssignedList.sessionId) {
      const savedPosition = scrollPositions.current[selectedAssignedList.sessionId];
      if (savedPosition !== undefined) {
        chatContainerRef.current.scrollTop = savedPosition;
      } else {
        // If no previous scroll position, scroll to bottom
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }
  }, [selectedAssignedList]);

  // Auto-scroll when new messages arrive
  useEffect(() => {
    if (!chatContainerRef.current) return;

    const chatContainer = chatContainerRef.current;

    // Check if user is near the bottom before updating
    const isAtBottom =
      chatContainer.scrollHeight - chatContainer.scrollTop <= chatContainer.clientHeight + 100;

    if (isAtBottom || messages.length === 1) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [messages]);


  const handleScrollToTop = () => {
    const currentPaginationInfo =
      paginationInfo[selectedAssignedList.identifier];

    if (!currentPaginationInfo) {
      console.error(`Pagination info not found for identifier: ${selectedAssignedList.identifier}`);
      return;
    }
    const { page_no, count } = currentPaginationInfo;
    if (count - 20 * page_no > 0) {
      dynamicUpdate({
        data: {
          key: `paginationInfo.${selectedAssignedList.identifier}`,
          value: {
            ...(paginationInfo[selectedAssignedList.identifier] || {}),
            page_no: page_no + 1,
          },
        },
      });
      // fetch more messages
      const msgs = messageList[selectedAssignedList.identifier];
      // configProcessor("getHistory", {
      //   identifier: selectedAssignedList.identifier,
      //   page_no: page_no + 1,
      //   timestamp: msgs[msgs.length - 1].timeStamp,
      // });
      if (msgs && msgs.length > 0) {
        configProcessor("getHistory", {
          identifier: selectedAssignedList.identifier,
          page_no: page_no + 1,
          timestamp: msgs[msgs.length - 1] && msgs[msgs.length - 1].message && msgs[msgs.length - 1].message.timeStamp,
          sessionId: selectedAssignedList && selectedAssignedList.sessionId || "",
        });
      } else {
        console.error("Message list is empty or undefined for the selected identifier.");
      }
    }
  };
  const [heightFromBottom, setHeightFromBottom] = useChatScrollHandler(
    chatContainerRef,
    handleScrollToTop,
    selectedAssignedList.identifier
  );

  const formatDate = (timestamp) => {
    const messageDate = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (messageDate.toDateString() === today.toDateString()) {
      return "Today";
    } else if (messageDate.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return messageDate.toLocaleDateString();
    }
  };

  const validMessages = messages.filter(m => m.message && Object.keys(m.message).length > 0);

  return (
    <div {...props} ref={chatContainerRef} id="message-screen-body">
      {loading ? <LoadingScreen /> : validMessages.map((data, i) => {
        const message = data.message;
        if (!message) {
          return null;
        }
        const messageDate = new Date(message.timeStamp).toDateString();
        const today = new Date().toDateString();
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayString = yesterday.toDateString();

        let dateLabel = messageDate === today ? "Today" : messageDate === yesterdayString ? "Yesterday" : messageDate;

        // const isLastMessageOfDate =
        //   i === messages.length - 1 ||
        //   new Date(messages[i + 1].message.timeStamp).toDateString() !== messageDate;

        // const isLastMessageOfDate =
        //   i === messages.length - 1 ||
        //   (messages[i + 1] && messages[i + 1].message && messages[i + 1].message.timeStamp && new Date(messages[i + 1].message.timeStamp).toDateString() !== messageDate);

        const isLastMessageOfDate =
          i === validMessages.length - 1 ||
          new Date(validMessages[i + 1] && validMessages[i + 1].message && validMessages[i + 1].message.timeStamp).toDateString() !== messageDate;

        return (
          // <React.Fragment>
          <React.Fragment key={`msg-${message.id || getUUID()}`}>
            <MessageScreenBodyItem
              key={(message && message.id) || getUUID()}
              data={data}
              selectedAssignedList={selectedAssignedList}
              showAvatar={
                i > 0
                  ? messages &&
                  messages[i - 1] &&
                  messages[i - 1].message &&
                  messages[i - 1].message.from !== message.from
                  : true
              }
            />

            {isLastMessageOfDate && (
              <div key={`date-${messageDate}`} className="date-separator">
                <span>{dateLabel}</span>
              </div>
            )}
          </React.Fragment>
        );
      })}
      {/* {loading && <LoadingScreen />}
      {messages.map((data, i) => {
        const message = data.message;
        if (!message) {
          return null;
        }
        return (
          <MessageScreenBodyItem
            key={(message && message.id) || getUUID()}
            data={data}
            selectedAssignedList={selectedAssignedList}
            showAvatar={
              i > 0
                ? messages &&
                messages[i - 1] &&
                messages[i - 1].message &&
                messages[i - 1].message.from !== message.from
                : true
            }
          />
        );
      })} */}
    </div>
  );
}

const stateToProps = (state) => ({
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  paginationInfo: chatSelector.getChatDynamic(state, "paginationInfo"),
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  messages: chatSelector.getCurrentChats(state),
  loading: chatSelector.getLoadingStatus(state),
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});

export default connect(stateToProps, dispatchToProps)(MessageScreenBody);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenBody/MessageScreenBody.js